import React, { ChangeEventHandler, HTMLInputTypeAttribute } from 'react';
import styles from './formInput.module.scss';
import { PersonalInformationFieldName } from '../PersonalInformationPage/PersonalInformationFieldName';

const fieldNameFirstname = 'firstname';
const fieldNameLastname = 'lastname';
const fieldNameEmail = 'email';
const fieldNameAddress = 'address';
const fieldNamePostalcode = 'postalcode';
const fieldNamePhoneNumber = 'phoneNumber';
const fieldNameDateOfBirth = 'dateOfBirth';
const fieldFreetext = 'freetext';

function getSpecialInputClass(fieldName: string) {
    if (fieldName === fieldNameDateOfBirth || fieldName === fieldNamePostalcode) {
        return styles.inputShort;
    } else {
        return '';
    }
}

function getDefaultText(fieldName: string) {
    if (fieldName === fieldNameFirstname) {
        return 'Kari';
    }
    if (fieldName === fieldNameLastname) {
        return 'Nordmann';
    }
    if (fieldName === fieldNameDateOfBirth) {
        return '01.01.1983';
    }
    if (fieldName === fieldNamePhoneNumber) {
        return '98 76 54 32';
    }
    if (fieldName === fieldNameEmail) {
        return 'karinordmann@epostadresse.no';
    }
    if (fieldName === fieldNameAddress) {
        return 'Gatenavn';
    }
    if (fieldName === fieldNamePostalcode) {
        return '1234';
    }
    if (fieldName === fieldFreetext) {
        return 'Navn eller medlemsnummer';
    } else {
        return '';
    }
}

const FormInput = (props: {
    label: string;
    fieldName: PersonalInformationFieldName;
    validateField: (fieldName: PersonalInformationFieldName, value: string) => void;
    onChange: ChangeEventHandler<HTMLInputElement>;
    inputValue: string | undefined;
    errorMessage: string;
    inputType: HTMLInputTypeAttribute;
    autoFocus?: boolean;
}) => {
    return (
        <div className={styles.formContainer}>
            <label htmlFor={props.fieldName} className={styles.inputLabel}>
                {props.label}
            </label>
            <input
                className={[styles.inputField, getSpecialInputClass(props.fieldName)].join(' ')}
                name={props.fieldName}
                id={props.fieldName}
                type={props.inputType}
                inputMode={props.fieldName === fieldNameDateOfBirth ? 'numeric' : 'text'}
                placeholder={getDefaultText(props.fieldName)}
                required={true}
                onChange={props.onChange}
                onBlur={(event) => props.validateField(props.fieldName, event.currentTarget.value)}
                value={props.inputValue}
                aria-invalid={props.errorMessage.length > 0}
                aria-describedby={'error-' + props.fieldName}
                autoFocus={props.autoFocus}
            />
            {props.errorMessage.length > 0 ? (
                <p className={styles.inputError} id={'error-' + props.fieldName} aria-live={'polite'}>
                    {props.errorMessage}
                </p>
            ) : (
                <div className={styles.inputError}></div>
            )}
        </div>
    );
};

export default FormInput;
